// extracted by mini-css-extract-plugin
export default {"companyContainer":"uM-z","companyImage":"vM-z","container":"wM-z","heading":"xM-z","darkText":"yM-z","smallHeading":"zM-z","darkBackground":"AM-z","whiteBackground":"BM-z"};